// extracted by mini-css-extract-plugin
export default {"container":"activities_container__lXgGU"};